import { render, staticRenderFns } from "./Restricted403.vue?vue&type=template&id=430b9e67&scoped=true"
import script from "./Restricted403.vue?vue&type=script&lang=js"
export * from "./Restricted403.vue?vue&type=script&lang=js"
import style0 from "./Restricted403.vue?vue&type=style&index=0&id=430b9e67&prod&scss=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b9e67",
  null
  
)

export default component.exports